import React from "react";
import { Link, useLocation } from "react-router-dom";

function useQuery() {
  const { search } = useLocation();
  return new URLSearchParams(search);
}

export const PasswordChangeCompleted = () => {
  const query = useQuery();
  const email = query.get("email") || "";

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]" data-model-id="10:835">
      <div className="bg-[#fff8e1] w-[412px] h-[917px] relative">

        <div className="absolute w-[412px] h-[201px] top-0 left-0 bg-[url('https://c.animaapp.com/mff1awnl8CTHcV/img/confetti.png')] bg-[length:100%_100%] bg-no-repeat">
          <div className="flex flex-col w-[412px] h-[50px] items-start pt-[21px] px-0 bg-[#fff8e1]">
            <div className="flex items-center justify-between w-full">
              <div className="flex w-[77px] items-center justify-center gap-2.5 pl-4 pr-[27px]" />
              <div className="w-[124px] h-2.5" />
            </div>
          </div>
        </div>

       
        <div className="absolute top-[203px] left-40 translate-y-[-1rem] animate-fade-in opacity-0 [--animation-delay:200ms]">
         
          <svg
            className="w-[92px] h-[90px] text-green-600"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <path d="M22 4 12 14.01l-3-3" />
          </svg>
        </div>

        <div className="absolute top-[406px] left-[99px] translate-y-[-1rem] animate-fade-in opacity-0 [--animation-delay:400ms]">
          <h1 className="[font-family:'Nunito',Helvetica] font-bold text-[#5d4037] text-2xl leading-[normal]">
            Password Changed 
          </h1>
        </div>

       
        <div className="absolute w-[309px] top-[451px] left-[52px] translate-y-[-1rem] animate-fade-in opacity-0 [--animation-delay:600ms]">
          <p className="[font-family:'Nunito',Helvetica] font-medium text-[#7a6f5c] text-base text-center leading-[21px]">

            {email
              ? `Password Changed Successfully for ${email}!`
              : "You have change your password successfully!"}
          </p>
        </div>

 
        <Link
          to="/auth/login"
          className="absolute w-[269px] h-[60px] top-[532px] left-[72px] translate-y-[-1rem] animate-fade-in opacity-0 [--animation-delay:800ms]
                     grid place-items-center rounded-[50px]
                     [font-family:'Nunito',Helvetica] font-bold text-base text-[#5d4037]
                     bg-[#ffd54f] hover:bg-[#ffcc02] transition-colors"
        >
          Back to Login
        </Link>
      </div>
    </div>
  );
};

export default PasswordChangeCompleted;
